module.exports = __webpack_public_path__ + "static/media/checkoutPage.cb4dfec3.png";